import { useState } from "react";
import { Sparkles, Square } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useStream } from "@/lib/useStream";
import { ADMIN } from "@/constants/testIds";

const btn = "px-3 py-1.5 rounded-full text-xs font-medium transition-colors";

export const ReviewReply = ({ r, onSaved }) => {
  const [text, setText] = useState(r.reply || "");
  const [saving, setSaving] = useState(false);
  const { busy, run, stop } = useStream();
  const dirty = text.trim() !== (r.reply || "");

  const suggest = async () => {
    if (busy) return stop();
    try { await run(`/admin/reviews/${r.id}/suggest-reply`, {}, setText); } catch (e) { toast.error(e.message || "Claude couldn't write a reply"); }
  };
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/admin/reviews/${r.id}/reply`, { reply: text });
      onSaved(r.id, data.reply);
      toast.success(data.reply ? (r.status === "approved" ? "Reply posted under the review" : "Reply saved; it shows once the review is on the shop") : "Reply removed");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="mt-3">
      <label className="text-xs font-semibold text-stone-600" htmlFor={`reply-${r.id}`}>Kiddee&rsquo;s reply</label>
      <textarea id={`reply-${r.id}`} data-testid={ADMIN.reviewReplyInput(r.id)} value={text} onChange={(e) => setText(e.target.value)} maxLength={400} rows={2}
        placeholder="Write a short thank-you from Kiddee" className="mt-1 w-full rounded-xl border border-[#E7E0D3] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#E06D44]/40" />
      <div className="mt-1 flex flex-wrap gap-2">
        <button type="button" data-testid={ADMIN.reviewReplySuggest(r.id)} onClick={suggest} className={`${btn} inline-flex items-center gap-1 ${busy ? "bg-[#1C1917] text-white" : "bg-[#F0EBE1] text-[#E06D44] hover:bg-[#E7E0D3]"}`}>
          {busy ? <><Square size={11} /> Stop</> : <><Sparkles size={13} /> Suggest with Claude</>}
        </button>
        <button type="button" data-testid={ADMIN.reviewReplySave(r.id)} onClick={save} disabled={!dirty || saving || busy} className={`${btn} bg-[#1C1917] text-white hover:bg-[#E06D44] disabled:opacity-40`}>
          {text.trim() || !r.reply ? "Save reply" : "Remove reply"}
        </button>
      </div>
    </div>
  );
};
